import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBroom} from "@fortawesome/pro-solid-svg-icons/faBroom";
import {faFilterList} from "@fortawesome/pro-solid-svg-icons/faFilterList";
import {FormatLocaleDate} from "@twigsby/helpers";
import {useTranslation} from "@twigsby/frontend-framework";
import {useSite} from "../../../Providers/SiteInterfaceProvider";
import FilterItem from "../../FilterItem";
import React from "react";
import {useSendMailHistory} from "../../../Providers/SendMailHistoryProvider";
import {Button, ButtonSize, ColourSolid, useLayout} from "@twigsby/frontend-framework";

type SendsHistoryFilterControlType = {

}

type SendHistoryFilterButtonType = {

}

const SendHistoryFilterButton = (props: SendHistoryFilterButtonType) => {
    const { t } = useTranslation();
    const { UpdateFilterActive } = useSendMailHistory();

    return (
        <Button
            squared={true}
            title={t('actions.filter')}
            colour={ColourSolid.Primary}
            icon={faFilterList}
            onClick={() => UpdateFilterActive(true)}
        />
    )
}

const SendsHistoryFilterControl = (props: SendsHistoryFilterControlType) => {
    const { t } = useTranslation();
    const { isMedium } = useLayout();
    const { currentLocale } = useSite();
    const { pageId, userId, HandleFilterRemoved, HandleFilterCleared, filterSettings } = useSendMailHistory();

    if(!filterSettings || Object.keys(filterSettings).length === 0) return null;

    return (
        <div className={'flex-row flex-wrap align-center flex-gap-xs'}>
            {!pageId && filterSettings.pageIds && (
                <FilterItem
                    content={t('counts.page', { count: filterSettings.pageIds.length })}
                    callback={() => HandleFilterRemoved('pageIds')}
                />
            )}

            {!userId && filterSettings.userIds && (
                <FilterItem
                    content={t('counts.user', { count: filterSettings.userIds.length })}
                    callback={() => HandleFilterRemoved('userIds')}
                />
            )}

            {filterSettings.startDate && (
                <FilterItem
                    content={t('startDate', { date: FormatLocaleDate(filterSettings.startDate, currentLocale) })}
                    callback={() => HandleFilterRemoved('startDate')}
                />
            )}

            {filterSettings.endDate && (
                <FilterItem
                    content={t('endDate', { date: FormatLocaleDate(filterSettings.endDate, currentLocale) })}
                    callback={() => HandleFilterRemoved('endDate')}
                />
            )}

            {Object.entries(filterSettings).length > 0 && !(Object.entries(filterSettings).length === 1 && (pageId && filterSettings.pageIds || userId && filterSettings.userIds)) && (
                <Button title={t('actions.clearFilters')} icon={faBroom} iconOnly={!isMedium} size={ButtonSize.Small} onClick={() => HandleFilterCleared()}/>
            )}
        </div>
    )
}

export default SendsHistoryFilterControl

export { SendHistoryFilterButton }
